// extracted by mini-css-extract-plugin
export default {"shop-wrap":"FxP0E_iUnWt8YL5CViec","shop-content":"uNgJ8hjcOaEVeIm8TcWd","store-list":"trUjUlSV_f_IYFAePyoY"};